import React, { useEffect } from 'react'
import ScreenWrapper from '~/components/screen_wrappers/screen_wrapper'
import { useNotification } from '@verzekeringapp-mono/shared/src/hooks/use_notification'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getNotifications as getNotificationsFromSelector, getNotificationsIsLoading } from '@verzekeringapp-mono/shared/src/state/selectors/notifications'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import LoadingIndicator from '~/components/LoadingIndicator'
import { format } from 'date-fns'
import { Link } from 'react-router-dom'

const NotificationsScreen: React.FC = () => {
  const notifications = useAppSelector(getNotificationsFromSelector)
  const { getNotifications, deleteNotification } = useNotification()
  const isLoading = useAppSelector(getNotificationsIsLoading)

  useEffect(() => {
    getNotifications()
  }, [])

  const onPressDelete = (notificationId: number) => {
    if (confirm('Weet je zeker dat je het bericht wil verwijderen?')) {
      deleteNotification(notificationId)
    }
  }

  return (
    <ScreenWrapper>
      {isLoading && notifications.length === 0 && (
        <div className='flex justify-center items-center'>
          <LoadingIndicator />
        </div>
      )}

      {notifications.length === 0 && !isLoading
        ? (
          <p className='paragraph-light'>Je hebt nog geen notificaties.</p>
        )
        : (
          notifications.map((notification) => (
            <Link
              to={`/notificaties/${notification.id}`}
              key={notification.id}
              className='mb-4 flex w-full flex-row items-center justify-between gap-4 rounded-md bg-surface-card p-4'
            >
              <div>
                <p className={`span ${notification.readAt ? '' : 'font-semibold'}`}>{notification.title}</p>

                <p className='paragraph-light'>
                  {format(new Date(notification.startDate), 'dd-MM-yyyy')}
                </p>
              </div>

              <div className='flex gap-4'>
                <button
                  onClick={e => {
                    e.preventDefault()
                    onPressDelete(notification.id)
                  }}
                >
                  <FontAwesomeIcon
                    icon='trash'
                    className='text-icon-brand'
                  />
                </button>

                <FontAwesomeIcon
                  icon={['fal', 'chevron-right']}
                  className='text-icon-secondary'
                />
              </div>
            </Link>
          ))
        )}
    </ScreenWrapper>
  )
}

export default NotificationsScreen
